export default "__VITE_ASSET__DCo4rM1z__"